(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-mood"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rc-mood')) {
    customElements.define(
      'rc-mood',
      class RcMood extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('data-rotate')) return;

          this.lines = Array.from(this.querySelectorAll('.rc-mood__line'));
          if (this.lines.length < 2) return;

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          if (reduceMotion.matches) return;

          this.index = 0;
          this.interval = parseInt(this.getAttribute('interval'), 10) || 5000;

          this.observer = new IntersectionObserver((entries) => {
            entries[0].isIntersecting ? this.start() : this.stop();
          });
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.stop();
          if (this.observer) this.observer.disconnect();
        }

        start() {
          if (this.timer) return;
          this.timer = setInterval(() => this.advance(), this.interval);
        }

        stop() {
          if (!this.timer) return;
          clearInterval(this.timer);
          this.timer = null;
        }

        advance() {
          const current = this.lines[this.index];
          this.index = (this.index + 1) % this.lines.length;
          const next = this.lines[this.index];

          current.classList.remove('is-active');
          current.setAttribute('aria-hidden', 'true');
          next.classList.add('is-active');
          next.removeAttribute('aria-hidden');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
